
import { NavigationBar } from "../NavigationBar"
import { Container } from "reactstrap"
import { Fragment } from "react";
import { Helmet } from "react-helmet"
import { COLORS } from "../../constants"

export function DashboardLayout({ children }) {
    return (
        <Fragment>
            <Helmet>
                <style>{`body { background-color: #f5f5f5; }`}</style>
            </Helmet>
            <NavigationBar />
            <Container className="pb-2 position-relative">
                <h4 className="mt-4" style={{ color: COLORS.text_dark_blue }}>My Account</h4>
                {/* {parent && <Link to="/store"><img src={balloon} className="balloon" /></Link>} */}
                {children}
            </Container>
        </Fragment>
    );
}